import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  StyleProps,
} from "@chakra-ui/react";

import { ListSites_listSites } from "graphql/generated";

import { useAllSitesData } from "common/all-sites-data";

import SitePreview from "./SitePreview";


interface IProps extends StyleProps {
  sites: ListSites_listSites[];
}


const SitesOverview: FunctionComponent<IProps> = ({
  sites,
}) => {
  const navigate = useNavigate();
  const { alarmsData, queuesData } = useAllSitesData();

  return (
    <Box className="honeycomb">
      { sites.map((site) => (
        <SitePreview
          name={site.name}
          location={site.location}
          online={site.online}
          hasAlarms={alarmsData[site.id]?.alarms.active_ns.length > 0}
          queue={queuesData[site.id]?.queue}
          onClickAlarms={() => {
            navigate(`/site/${site.id}/${alarmsData[site.id]?.alarms.alarms_nav_tab}`);
          }}
          onClick={() => {
            navigate(`/site/${site.id}`);
          }}
        />
      )) }
      <li className="honeycomb-cell honeycomb__placeholder"></li>
    </Box>
  );
};

export default SitesOverview;
